'use client'
import { LineShareAndroid } from '@qr-front/icons/line-share-android'
import { Button } from '@qr-front/ui/components/Button'
import { useSetAtom } from 'jotai'

import { shareQrDialogAtom, shareQrLinkAtom } from '../../dialogsState'

export const ShareButton = ({ uri }: { uri: string }) => {
	const setShareQrOpen = useSetAtom(shareQrDialogAtom)
	const setShareQrLink = useSetAtom(shareQrLinkAtom)

	return (
		<Button
			visual="soft-shadow"
			aria-label="Share"
			onClick={() => {
				setShareQrOpen(true)
				setShareQrLink(uri)
			}}
		>
			<LineShareAndroid className="size-4" />
		</Button>
	)
}
